import Styles from '../../../../ArticlesComponents/ArticleWrapper/styles.module.scss';

export default function Definitions() {
  return (
    <>
      <div className={Styles.row}>
        <div className={Styles.title}>API Infrastructure</div>
        <div className={Styles.description}>
          means the Information Service Provider’s computer hardware, firmware, software, mobile apps (including “widgets”)
          and other communications infrastructure that are within its reasonable control and which is used to facilitate access
          to and use of the Services by the Customer.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Applications</div>
        <div className={Styles.description}>
          means the selected information services, provided by the Information Service Provider, which shall be made available to
          the Customer, as detailed in the activation email sent to the Customer after its order is accepted and processed.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Business Day</div>
        <div className={Styles.description}>
          means any day other than Saturday or Sunday that is not a bank or public holiday.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Business Hour</div>
        <div className={Styles.description}>
          means any time between 9am and 6pm on a Business Day, during which the Information Service Provider is open for business.
        </div>
      </div>
      
      <div className={Styles.row}>
        <div className={Styles.title}>Commencement Date</div>
        <div className={Styles.description}>
          means the date on which the activation email is sent to the Customer and the Contract for Services is formed, as described below.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Confidential Information</div>
        <div className={Styles.description}>
          means all business, technical, financial or other information created or exchanged between the Parties throughout the Term of this
          Contract for Services.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Customer</div>
        <div className={Styles.description}>
          means the business entity (or, if a person is not acting on behalf of a business entity, the individual)
          that has registered to receive the Services.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Customer Computer Systems</div>
        <div className={Styles.description}>
          means the Customer’s computer hardware, firmware, software and communications infrastructure through and on which the Services are to be used.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Customer Data</div>
        <div className={Styles.description}>
          means any data belonging to the Customer or to third parties and used by the Customer under licence which is created by the
          Customer or otherwise stored in the API Infrastructure.
        </div>
      </div>
      
      <div className={Styles.row}>
        <div className={Styles.title}>Fees</div>
        <div className={Styles.description}>
          means the sums payable by the Customer in return for access to the Services (i.e. to the Applications, the API Infrastructure and support
          services provided by the Information Service Provider in accordance with Clauses for ‘fees and payments’ and ‘support’ of this Contract for Services.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Intellectual Property Rights</div>
        <div className={Styles.description}>
          means all vested contingent and future intellectual property rights including but not limited to copyright,
          trade marks, service marks, design rights (whether registered or unregistered), patents, know-how, trade secrets, inventions, get-up and database rights.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Service/s</div>
        <div className={Styles.description}>
          means, collectively, the Applications, API Infrastructure and support services provided by the Information Service Provider to the Customer.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Term</div>
        <div className={Styles.description}>
          means the duration of the Contract for Services, as defined below.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Users</div>
        <div className={Styles.description}>
          means an employee or other authorised agent of the Customer who shall, from time to time, access the Applications through the API Infrastructure.
        </div>
      </div>
      <div className={Styles.row}>
        <div className={Styles.title}>Writing</div>
        <div className={Styles.description}>
          unless the context otherwise requires, each reference in this Contract for Services to “writing” includes any communication by email, fax or other electronic or similar means.
        </div>
      </div>
    </>
  );
}
